// extracted by mini-css-extract-plugin
export var authorByLineTooltipTrigger = "Y_c0";
export var authorBylineContainer = "Y_cY";
export var authorPrefix = "Y_cZ";